export const graphpaperWall = `\
-- graph paper
-- uniform squares, thin black grid lines

@unit 20px
@height 20px
@gap 1px
@mortar black
@color white
@shadow none

1
`
